export default ({ app, error, route, redirect }) => {
  const protectProductNameDimensionsRedirect = (redirectPath, requestedPath = '') => {
    const match = requestedPath.match(/^\/(produkt|product)\/(.+)-(\d+)x(\d+)-cm\/?$/)

    if (!match || !redirectPath) {
      return redirectPath
    }

    const [, prefix, baseSlug, width, height] = match
    const wrongPath = `/${prefix}/${baseSlug}-${width}-${height}`
    const normalizedRedirectPath = redirectPath.replace(/\/$/, '')

    if (normalizedRedirectPath === wrongPath) return null

    return redirectPath
  }

  app.$pageNotFound = async ({ type, slug, path }) => {
    const response = await app.$axios.$get(`${app.$env.CMS_URL}/redirect`, {
      params: {
        route: route.path,
        path: path || route.path,
        slug,
        type,
      },
      validateStatus: false,
    })
    if (response && response.redirectPath && response.redirectPath !== (path || route.path)) {
      const redirectPath = protectProductNameDimensionsRedirect(response.redirectPath, path || route.path)

      return redirectPath ? redirect(301, redirectPath) : error({ statusCode: 404 })
    } else {
      return error({ statusCode: 404 })
    }
  }
}
